import useSessionRegistrationAnalytics from '../../hooks/useSessionRegistrationAnalytics';

export default function SessionRegistrationAnalytics({ children, enabled, guestId, eventId }) {
    useSessionRegistrationAnalytics({ enabled, guestId, eventId });

    return children;
}
